import SkillsInterestsEdit from './skillsInterestsEdit'
export default SkillsInterestsEdit
